import React from 'react';
import Submenu from './Submenu';
import { getProductUrl } from '../../../utils/urls/productUrls.js';

import config from '../../../config';

class FavoritesMenu extends Submenu {
  static propTypes = {
    user: React.PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);
    this.config = config;
    this.favorites = props.favorites || this.props.user.favorites || [];
    this.userType = props.user.type || 'non-registered';
    this.analytics = this.props.analytics;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.favorites) {
      this.favorites = nextProps.favorites;
    }
  }

  clickedFavorite = (link, name) => {}

  clickedTryPremium = () => {}

  clickedSignIn = () => {}

  clickedRenew = () => {}

  render() {
    const navClasses = super.getMenuClasses('favoritesMenu');
    if (this.favorites.length > 0 || this.userType !== 'non-registered') {
      return (
        <ul className={navClasses} id="favoritesMenu">
          <li className="header">Your Favorites</li>

          {(() => { // user with no favorites
            if (this.favorites.length === 0) {
              return (
                <div>
                  <li className="touch" style={{marginBottom: '15px'}}>
                    Pick a point and view a<br/> forecast to save a favorite
                  </li>
                  <li className="desktop info">
                    <div style={{margin: '10px'}}>
                      Pick a point and view a forecast to save a favorite
                    </div>
                  </li>
                </div>
              );
            }
          })()}

          { // user with favorites
            this.favorites.map((favorite, index) => {
              const hidden = (index > 14) ? 'touch' : '';
              return (
                <li key={index} className={`default ${hidden}`}>
                  <a onClick={this.clickedFavorite.bind(this, getProductUrl(favorite), favorite.name)}
                    href={getProductUrl(favorite)}>
                    {favorite.name}
                  </a>
                </li>
              );
            })
          }

          {(() => { // user with too many favorites
            if (this.favorites.length > 15) {
              return (
                <div>
                  <li className="desktop info">
                    <div style={{margin: '10px'}}>
                      View map for remaining favorites
                    </div>
                  </li>
                </div>
              );
            }
          })()}
        </ul>
      );
    }
    return (
      <ul className={navClasses} id="favoritesMenu">

        {(() => { // non registered
          if (this.userType === 'non-registered') {
            return (
              <div>
                <li className="header">Favorites</li>
                <li className="touch" style={{marginBottom: '15px'}}>Register to begin<br /> saving favorites.</li>
                <li className="touch">
                  <a
                    onClick={this.clickedTryPremium}
                    href={this.config.links.funnel.registerNow}
                    className="btn btn-success">
                    Register Now
                  </a>
                </li>
              </div>
            );
          }
        })()}

        {(() => { // non-registered user who needs to login
          if (this.userType === 'non-registered') {
            return (
              <div>
                <li className="divider"><span>or</span></li>
                <li className="touch" style={{marginBottom: '15px'}}>Sign in to access<br/> existing favorites</li>
                <li>
                  <a
                    onClick={this.clickedSignIn}
                    href={super.exitLink(this.config.links.funnel.login)}
                    className="btn btn-primary">
                    Sign In
                  </a>
                </li>
              </div>
            );
          }
        })()}

        {(() => { // non-registered / registered users on the desktop.
          if (this.userType === 'non-registered') {
            return (
              <li className="desktop info">
                <div style={{margin: '10px'}}>
                  Try Premium to begin saving favorites.
                </div>
              </li>
            );
          }
        })()}

      </ul>
    );
  }
}

export default FavoritesMenu;



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/menus/FavoritesMenu.js